import { Component, OnInit } from "@angular/core";

@Component({
  selector: "CardBody",
  templateUrl: "./card-body.component.html",
  styleUrls: ["./card-body.component.sass"],
})
export class CardBodyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
